
angular.module('app.filters')
  .filter(
    'limitWord',
    function(){
    	return function(text,limit,moreChar){
    		limit = parseInt(limit) || 8;
    		return limitWord(text,limit, moreChar);
    	}
    })
;

function limitWord (text,limit, moreChar){
  let i=0;
	let escapedTrimmedText = text.replace(/[\n,'↵']/g, ' ').trim(),
      limitedText = escapedTrimmedText.split(' ');

	if(limitedText.length < limit){
		return text;
	}else{
		limitedText = escapedTrimmedText.split(' ',limit);
		text = limitedText.join(' ');
		return text;
	}
}



// WEBPACK FOOTER //
// ./scripts/shared/filters/limit-word.js